import React from 'react';
var SearchContext = React.createContext({
  expandTree: false,
  searchPropertiesPhrase: null
});
export default SearchContext;